export default __webpack_public_path__ + "static/media/BrandonGrotesque-Regular.5adb92d8.woff2";